<script lang="ts">
    export let isStoreCreditEnabled: boolean;
    export let storeCreditBalance: string | null;

    interface $$Slots {
        default: {
            storeCreditBalance: string;
        };
    }
</script>

{#if isStoreCreditEnabled && storeCreditBalance !== null}
    <slot storeCreditBalance={storeCreditBalance || "0"} />
{/if}
